export const siteInfo = {
  name: "18爆料网",
  slogan: "吃瓜不迷路，每天都有新瓜",
  tagline: "娱乐爆料 · 热点观察",
  description:
    "18爆料网是一个聚合娱乐热点、明星动态与圈内话题的内容门户，覆盖明星塌房、艺人黑历史、娱乐圈内幕与综艺瓜田等栏目，帮助读者快速梳理热点脉络。",
  email: "hello@18baoliao.com",
  contactLabel: "线索投稿与合作",
  founded: "2021",
  stats: [
    { label: "收录爆料", value: "8600+" },
    { label: "活跃栏目", value: "12" },
    { label: "日更条数", value: "40+" },
    { label: "读者订阅", value: "23w" },
  ],
};

export const navLinks = [
  { to: "/", label: "首页" },
  { to: "/hot", label: "热榜" },
  { to: "/topics", label: "栏目" },
  { to: "/about", label: "关于我们" },
];

export const tickerItems = [
  "顶流男演员深夜行程被拍，工作室暂未回应",
  "综艺录制现场花絮流出，剪辑顺序引热议",
  "人气女歌手新专辑先行曲登顶热歌榜",
  "某剧组换角风波后续：官方发布说明",
  "音乐节阵容官宣，票价与场次成为讨论焦点",
  "短剧演员片场互动视频走红，双方工作室回应",
];

export const faqs = [
  {
    q: "18爆料网的内容主要来自哪里？",
    a: "内容由编辑团队整理公开报道、社交平台热点与读者投稿线索，再经过事实核对与多源比对后成稿，标注来源与时间，方便读者自行判断。",
  },
  {
    q: "热榜的排名是怎么计算的？",
    a: "热榜综合话题的讨论量、搜索趋势、媒体提及次数与读者阅读时长加权得出，每两小时更新一次，并提供日榜与周榜两个维度。",
  },
  {
    q: "如何向网站投稿爆料线索？",
    a: "你可以通过页面底部的订阅与投稿入口提交线索。我们会对线索做初步核实，涉及隐私或未经证实的信息不会直接发布。",
  },
  {
    q: "为什么有的帖子只有讨论没有结论？",
    a: "娱乐话题往往处于持续发展中。对于尚未有明确回应的事件，我们会保留讨论空间并标注进展节点，避免给出主观定性。",
  },
  {
    q: "订阅吃瓜日报会收到什么？",
    a: "每天一封邮件，包含当日热榜前三、值得关注的深度专题以及一份简短的娱乐日历，不含广告内容，可随时退订。",
  },
];

export const testimonials = [
  {
    name: "阿哲",
    role: "追剧十年的老观众",
    quote:
      "最舒服的一点是它把时间线理得很清楚。以前刷到的瓜都是碎片，这里能看到前因后果，讨论起来也有依据。",
  },
  {
    name: "小满",
    role: "自媒体内容运营",
    quote:
      "做选题的时候会先来这里看热榜，分类做得很细，综艺、恋情、作品动态分开，找素材效率高了不少。",
  },
  {
    name: "橘子汽水",
    role: "吃瓜小组组长",
    quote:
      "更新快，而且很少标题党。有的帖子会明确写「待回应」，这种克制反而让人愿意长期看下去。",
  },
];